import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';

// Shared components

import PortletContent from 'components/PortletContent';

// Material components

import Typography from '@material-ui/core/Typography';

import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Avatar from '@material-ui/core/Avatar';

// Material Helpers

import { withStyles } from '@material-ui/core/styles';

// Externals 
import classNames from 'classnames';
import compose from 'recompose/compose';

import { withTranslation } from 'react-i18next';
// Component styles
import styles from './styles';

import { api_host, api_auth } from '../../../../../common/globals/constants';
import moment from 'moment'
import 'moment/locale/es'  
import { reportFetchError } from '../../../../../observability/rum';
moment.locale('es')


class AvailabilityGaugeChartLight extends Component {

    _currentObjectiveId = null;

    constructor(props) {

        super(props);

        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,   
            externalData: null,
            dataError: false,
            isLoading: true,
            time: 'h',            
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            date: this.props.params.date,
            isRefresh: this.props.params.isRefresh,
            dateMoment:((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")),
            uptime: 0,
            uptimeWeek: 0,
            mediciones: 0
        }

    }
   
    static getDerivedStateFromProps(nextProps, prevState) {
        
        /*if (nextProps.match.params.objetivo_id !== prevState.prevObjectiveId) {
            return {
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                chartBaseColor: null,
                chartOptions: prevState.chartOptionsBase,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod,
            }
        } else */if (nextProps.params.state.period !== prevState.time) {
            return {
               
                externalData: null,
                //prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.state.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                //statePeriod: nextProps.params.statePeriod,
                //isStatePeriod: nextProps.params.isStatePeriod
            }
        }/* else if ((nextProps.params.period === prevState.time) && (nextProps.params.statePeriod !== prevState.statePeriod)) {
            return {
                chartOptions: prevState.chartOptionsBase,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod,
                isStatePeriod: nextProps.params.isStatePeriod
            }
        } else if(nextProps.params.isRefresh !== prevState.isRefresh){
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod,
                isRefresh: nextProps.params.isRefresh,          
            }

        } else if(nextProps.params.date !== prevState.date){
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod,
                date: nextProps.params.date,          
            }

        }*/
        return null;
    }

    componentDidMount() {

        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        /*if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }*/

        if (prevProps.params.state.period !== this.state.time) {
                this.getDataFromAPI();
        }

    }


    getDataFromAPI = (objectiveId) => {

        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        const { obj } = this.props.params.props
        const { listObjectives } = this.props.params.props
        const { period, statePeriod } = this.props.params.state
  
        let listObjective = []
        Object.keys(listObjectives).map(key => {            
            Object.keys(listObjectives[key]).map(key2 => {
                if (listObjectives[key][key2].objetivo_id == obj){
                    listObjective.push(listObjectives[key][key2]);
                }
            })
        })
        let sla_rendimiento_ok = parseInt(listObjective[0].sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(listObjective[0].sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(listObjective[0].sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(listObjective[0].sla_disponibilidad_error)
        Promise.all([
                fetch(api_host + `/reporte/online/indicadores/getDisponibility/?user=${user}&key=${api_auth}&objetivoId=${obj}&t=${period}&token=${token}`),
                fetch(api_host + `/reporte/online/indicadores/getDisponibility/?user=${user}&key=${api_auth}&objetivoId=${obj}&t=w&token=${token}`),
                fetch(api_host + `/reporte/online/indicadores/getTotalMediciones/?user=${user}&key=${api_auth}&objetivoId=${obj}&t=${period}&token=${token}&horarioId=0`)
            ])
            .then(([res1, res2, res3]) => {
                return Promise.all([res1.json(), res2.json(), res3.json()])
            })
            .then(([res1, res2, res3]) => {
                // Se define el state de acuerdo a la petición y respuesta de la promesa 
                if (res1.status == 1 || res1.status == 5 || res2.status == 1 || res2.status == 5 || res3.status == 1 || res3.status == 5) {
                    localStorage.setItem('isAuthenticated', false);                        
                } else {
                    //Procesa la Data Recibida
                    try {
                        this.processData(res1, sla_rendimiento_ok,
                            sla_rendimiento_error,
                            sla_disponibilidad_ok,
                            sla_disponibilidad_error,
                            period, res2, res3)
                        /*if (this.state.lastEvent !== []) {
                            this.props.params.onFirstInfo(this.state.lastEvent)
                        }*/
                    } catch (error) {
                        this.setState({
                            dataError: true,
                            data: null,
                            isLoading: false
                        });
                    }
                }

            })
            .catch(error => {
                reportFetchError('AvailabilityGaugeChartLight', error);
                this.setState({ dataError: true, data: null, isLoading: false });
            });

    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,      
        externalDataWeek,
        externalDataMediciones) => {

            // Si hay datos defindos         
            const uptime = externalData.data.uptime + externalData.data['evento_cliente'] + externalData.data['marcado_atentus'];
            const uptimeWeek = externalDataWeek.data.uptime + externalDataWeek.data['evento_cliente'] + externalDataWeek.data['marcado_atentus'];
            const mediciones = externalDataMediciones.mediciones;
            this.setState({
                uptime: uptime,
                uptimeWeek: uptimeWeek,
                dataError: false,
                isLoading: false,
                mediciones: mediciones,
                //lastEvent: lastEventDict,
                time: period
            });
            //}
    }



    render() {       
        const { dataError, isLoading, uptime, uptimeWeek, mediciones} = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };
        const {classes} = this.props
        const t = (this.props && this.props.t) ? this.props.t : (s => s) 
        if (!dataError) {
            return (<FormattedChart uptime={uptime} uptimeWeek={uptimeWeek} style={style} styleHidden={styleHidden} mediciones={mediciones} classes={classes} t={t}/>)
        }
        else if (dataError) {
            return (<p>{t('modal.objective.render.no-data')}</p>)
        }
        else return (<p>{t('modal.objective.render.error')}</p>)
    }
}

function FormattedChart(props) {

    return (
        <div >
            <div style={props.styleHidden}>
                <PortletContent>
                    <PerfectScrollbar>
                        <Typography
                            variant="h5"
                            style={{color:"white"}}
                            >
                            <CircularProgress
                            variant="indeterminate"
                            size={24}
                            thickness={4}                            
                            />
                            <br/>
                            {props.t('text.loading')}
                        </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            </div>
            <div style={props.style} >  
                <Table style={{overflowX: 'auto'}} aria-label="spanning table" >
              
                    <TableBody>

                        <TableRow >
                            <TableCell style={{borderBottom: "none"}}>
                                <Typography style={{float:"left", fontWeight:200}} variant="h1" component="h3" gutterBottom>
                                {props.t('modal.objective.graph.uptime-period.title')}<br/>
                                </Typography> 
                            </TableCell>
                            <TableCell style={{borderBottom: "none"}}>
                                <Typography style={{float:"left", fontWeight:800}} variant="h2" component="h3" gutterBottom >
                                {props.uptime > 100 ? 100.00 : parseFloat(props.uptime.toFixed(2))} %<br/>
                                </Typography> 
                            </TableCell>
                        </TableRow>                    
                        <TableRow >
                            <TableCell style={{borderBottom: "none"}}>
                                <Typography style={{float:"left", fontWeight:200}} variant="h3" component="h5" gutterBottom>
                                {props.t('modal.objective.graph.uptime-weekly.title')} <br/>
                                </Typography> 
                            </TableCell>
                            <TableCell style={{borderBottom: "none"}}>
                                <Typography style={{float:"left", fontWeight:600}} variant="h3" component="h5" gutterBottom >
                                {props.uptimeWeek > 100 ? 100.00 : parseFloat(props.uptimeWeek.toFixed(2))} %<br/>
                                </Typography> 
                            </TableCell>
                        </TableRow>
                      
                        <TableRow >
                            <TableCell style={{borderBottom: "none", textAlign: "center"}}>
                                <Typography style={{float:"left", fontWeight:200}} variant="h4" component="h5" gutterBottom>
                                {props.t('modal.objective.graph.total-measurements')}  <br/>
                                </Typography> 
                            </TableCell>
                            <TableCell style={{borderBottom: "none", textAlign: "center"}}>
                                <Typography style={{float:"left", fontWeight:800}} variant="h4" component="h5" gutterBottom >
                                     {props.mediciones}
                                <br/>
                                </Typography>
                            </TableCell>
                        </TableRow>
                       
                    </TableBody>
                </Table>
           
                     
            </div>
        </div>
    )
}


//export default withRouter(AvailabilityGaugeChartLight);

export default compose(withRouter, withStyles(styles), withTranslation())(AvailabilityGaugeChartLight);